

























import { Component, Vue, Prop } from 'vue-property-decorator';
import HvgpassModal from '@hvg/hvgpass-modal';
import Cookie from 'js-cookie';
import config from './LoginWrapperConfig';

@Component({
  components: {
    HvgpassModal,
  },
})
export default class App extends Vue {
  @Prop() public baseUrl!: string;
  @Prop() public googleClientId!: string;
  @Prop() public profileUrl!: string;
  @Prop() public tokenCookieDomain!: string;
  @Prop() public loginButtonType!: string;
  @Prop() public mountPointId!: string;
  @Prop() public ssoUrl!: string;
  @Prop() public ssoSiteId!: string;
  public token: string | null = null;

  public beforeMount(): void {
    const token = Cookie.get('token');
    if (token) {
      this.token = token;
    }
  }

  public mounted(): void {
    if (this.initialScreen) {
      this.openModal();
    }
  }

  get isLoggedIn() {
    return !!this.token;
  }

  get initialScreen() {
    const hash = location.hash;
    if (!hash) {
      return undefined;
    }

    if (hash.startsWith('#password-change')) {
      return 'password-change';
    }

    return undefined;
  }

  get passwordChangeToken() {
    const hash = location.hash;
    if (!hash) {
      return null;
    }
    const matches = hash.match(/token=(.*)$/);
    if (!matches || !matches.length || matches.length !== 2) {
      return null;
    }

    return matches[1];
  }

  public openModal(): void {
    Vue.nextTick(() => {
      (this.$refs.hvgpassModal as any).show();
    });
  }

  public success(token: string, ssoRedirectUrl: string): void {
    Cookie.set('token', token, { expires: 360, domain: this.tokenCookieDomain });
    this.token = token;

    config.succeeded(token, ssoRedirectUrl);
  }
  public authFailed() {
    config.failed();
  }
}
